import type { PortfolioItem } from '../types'

export const portfolioItems: PortfolioItem[] = [
  {
    id: 'proj-1',
    title: 'Computer Shop — eCommerce Store',
    category: 'ecommerce',
    thumbnail: '/images/port-01.jpg',
    images: [
      '/images/port-01.jpg',
    ],
    description:
      'A fully-featured computer shop eCommerce platform with product catalog, inventory management, and secure checkout for tech enthusiasts.',
    client: 'Computer Shop',
    date: '2025-12',
    url: 'https://computershop.smartsupporttech.in',
    technologies: ['React', 'Node.js', 'MongoDB', 'Stripe', 'Tailwind CSS'],
    featured: true,
  },
  {
    id: 'proj-2',
    title: 'Dental Clinics — Healthcare Portal',
    category: 'web-design',
    thumbnail: '/images/port-02.jpg',
    images: [
      '/images/port-02.jpg',
    ],
    description:
      'A professional dental clinic website with appointment booking, service listings, doctor profiles, and patient education resources.',
    client: 'Dental Clinics',
    date: '2025-09',
    url: 'https://dentalclinicx.smartsupporttech.in',
    technologies: ['Next.js', 'TypeScript', 'Tailwind CSS', 'PostgreSQL'],
    featured: true,
  },
  {
    id: 'proj-3',
    title: 'Furniture Showrooms — Online Showcase',
    category: 'ecommerce',
    thumbnail: '/images/port-03.jpg',
    images: [
      '/images/port-03.jpg',
    ],
    description:
      'An elegant furniture showroom website with virtual room staging, product catalog, and inquiry management system.',
    client: 'Furniture Showrooms',
    date: '2025-06',
    url: 'https://furnitureshop.smartsupporttech.in',
    technologies: ['React', 'Shopify', 'Stripe', 'Tailwind CSS'],
    featured: true,
  },
  {
    id: 'proj-4',
    title: 'Jewelries — Premium eCommerce',
    category: 'ecommerce',
    thumbnail: '/images/port-04.jpg',
    images: [
      '/images/port-04.jpg',
    ],
    description:
      'A luxury jewelry eCommerce store with high-res product zoom, custom ring builder, and secure checkout experience.',
    client: 'Jewelries',
    date: '2025-04',
    url: 'https://jewelry.smartsupporttech.in',
    technologies: ['Next.js', 'Sanity CMS', 'Stripe', 'Framer Motion'],
    featured: false,
  },
  {
    id: 'proj-5',
    title: 'Restaurant — Digital Dining Experience',
    category: 'web-design',
    thumbnail: '/images/port-05.jpg',
    images: [
      '/images/port-05.jpg',
    ],
    description:
      'A modern restaurant website with online menu, table reservation system, food delivery integration, and photo gallery.',
    client: 'Restaurant',
    date: '2025-02',
    url: 'https://restaurant.smartsupporttech.in',
    technologies: ['React', 'Node.js', 'MongoDB', 'Socket.io'],
    featured: true,
  },
  {
    id: 'proj-6',
    title: 'Used Cars Showroom — Auto Marketplace',
    category: 'ecommerce',
    thumbnail: '/images/port-06.jpg',
    images: [
      '/images/port-06.jpg',
    ],
    description:
      'A used car showroom platform with vehicle listings, advanced search filters, financing calculator, and test drive booking.',
    client: 'Used Cars Showroom',
    date: '2024-11',
    url: 'https://usedcars.smartsupporttech.in',
    technologies: ['Next.js', 'PostgreSQL', 'Prisma', 'Tailwind'],
    featured: false,
  },
  {
    id: 'proj-7',
    title: 'MEP Engineering — Corporate Website',
    category: 'web-design',
    thumbnail: '/images/port-07.jpg',
    images: [
      '/images/port-07.jpg',
    ],
    description:
      'A professional MEP engineering company website showcasing services, project portfolio, technical expertise, and client testimonials.',
    client: 'MEP Engineering',
    date: '2024-09',
    url: 'https://mep-engineering.smartsupporttech.in',
    technologies: ['React', 'Node.js', 'Tailwind CSS', 'GSAP'],
    featured: false,
  },
  {
    id: 'proj-8',
    title: 'HVAC Services — Service Provider Platform',
    category: 'web-design',
    thumbnail: '/images/port-08.jpg',
    images: [
      '/images/port-08.jpg',
    ],
    description:
      'A comprehensive HVAC services website with service booking, maintenance plans, technician profiles, and customer portal.',
    client: 'HVAC Services',
    date: '2024-07',
    url: 'https://hvac.smartsupporttech.in',
    technologies: ['React', 'TypeScript', 'Firebase', 'Tailwind CSS'],
    featured: false,
  },
  {
    id: 'proj-9',
    title: 'UrbanEats — Food Delivery App',
    category: 'development',
    thumbnail: '/images/port-09.jpg',
    images: [
      '/images/port-09.jpg',
    ],
    description:
      'A food delivery marketplace with real-time tracking, smart routing, and a dynamic pricing engine for restaurants.',
    client: 'UrbanEats',
    date: '2024-05',
    technologies: ['React Native', 'Node.js', 'Socket.io', 'MongoDB', 'Google Maps'],
    featured: false,
  },
  {
    id: 'proj-10',
    title: 'TechFlow — SaaS Dashboard',
    category: 'web-design',
    thumbnail: '/images/port-10.jpg',
    images: [
      '/images/port-10.jpg',
    ],
    description:
      'A comprehensive SaaS analytics dashboard with customizable widgets, real-time data visualization, and team collaboration features.',
    client: 'TechFlow Inc.',
    date: '2024-03',
    technologies: ['React', 'D3.js', 'Redux', 'Node.js', 'WebSocket'],
    featured: true,
  },
  {
    id: 'proj-11',
    title: 'LuxeWheels — Auto Dealer Platform',
    category: 'ecommerce',
    thumbnail: '/images/port-11.jpg',
    images: [
      '/images/port-11.jpg',
    ],
    description:
      'A premium car dealership platform with 3D vehicle configurator, financing calculator, and inventory management system.',
    client: 'LuxeWheels Motors',
    date: '2024-01',
    technologies: ['Next.js', 'Three.js', 'Strapi', 'Stripe', 'Tailwind'],
    featured: false,
  },
  {
    id: 'proj-12',
    title: 'VoxPop — Social Analytics Tool',
    category: 'seo',
    thumbnail: '/images/port-12.jpg',
    images: [
      '/images/port-12.jpg',
    ],
    description:
      'A social media analytics platform with sentiment analysis, competitor tracking, and automated reporting for marketing teams.',
    client: 'VoxPop Media',
    date: '2023-10',
    technologies: ['React', 'Python', 'FastAPI', 'PostgreSQL', 'Redis'],
    featured: false,
  },
]
